module.exports = __webpack_public_path__ + "media/icons/successful-c105b57b.svg";